/** @flow */
import * as React from 'react';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router';
import styled from 'styled-components';
import CampaignDashboardListing from 'common/modules/campaign/domain/CampaignDashboardListing';
import * as Routes from 'statsradio/helpers/constant/Routes';

import { StyledRow, Table, Td, TdEmphasis, Th, ThRight } from '../CampaignDashboardTable';

export const TdLink = styled.td`
  font-size: ${({ theme }) => theme.V2.fonts.button.size}px;
  letter-spacing: ${({ theme }) => theme.V2.fonts.button.letterSpacing}px;
  font-weight: ${({ theme }) => theme.V2.fonts.button.weight};
  text-align: right;
  color: #00a89e; 
  padding: ${({ theme }) => theme.V2.metrics.margin.tiny}px ${({ theme }) => theme.V2.metrics.margin.normal}px;
`;

export const TdError = styled(Td)`
  color: red;
  font-weight: bold;
`;

interface Props {
  t: any;
  history: any;

  campaigns: CampaignDashboardListing[];
}

function onCampaignClick(campaignReference: string, history: any) {
  history.push(Routes.CAMPAIGN(campaignReference));
}

function onLinkCampaignClick(event: any, campaignReference: string, history: any) {
  event.preventDefault();
  event.stopPropagation();

  history.push({
    pathname: Routes.CAMPAIGN(campaignReference),
    state: { openLinkingDialog: true },
  });
}

function renderRow(campaign: CampaignDashboardListing, t: any, history: any) {
  let date;
  if (campaign.isStartedSince(0)) {
    date = <TdError>{campaign.startAt.fromNow()}</TdError>;
  } else if (campaign.isStartedSince(5)) {
    date = <TdEmphasis>{campaign.startAt.fromNow()}</TdEmphasis>;
  } else {
    date = <Td>{campaign.startAt.fromNow()}</Td>;
  }

  return (
    <StyledRow key={campaign.reference} onClick={() => onCampaignClick(campaign.reference, history)}>
      <Td>{campaign.name}</Td>
      {date}
      <TdLink onClick={e => onLinkCampaignClick(e, campaign.reference, history)}>
        {t('link').toUpperCase()}
      </TdLink>
    </StyledRow>
  );
}

function CampaignsToLinkTable({ t, campaigns, history }: Props) {
  return (
    <Table width="100%">
      <thead>
        <tr>
          <Th width="52%">{t('campaignName')}</Th>
          <Th width="25%">{t('start')}</Th>
          <ThRight width="23%" />
        </tr>
      </thead>
      <tbody>
        {campaigns.map(c => renderRow(c, t, history))}
      </tbody>
    </Table>
  );
}

export default translate('salesDashboard')(withRouter(CampaignsToLinkTable));



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesDashboard/components/campaignsToLink/CampaignsToLinkTable.js